import {GridFilterDropdown} from './grid-filter-dropdown';

export class GridFilterMultiselect extends GridFilterDropdown {

}
